import * as OrderBL from './order-bl'
import * as MessagingBL from './messaging-bl'
import * as AuthDAL from '../dal/auth-dal'
import * as OrderDAL from '../dal/order-dal'
import * as UserDAL from '../dal/user-dal'
import * as SettingsDAL from '../dal/settings-dal'
import * as UserBL from '../bl/user-bl'
import * as BusinessBL from '../bl/business-bl'

import { useEmulator } from "../../local-config";
import { get } from "svelte/store";
import { clearCart, fcmToken } from '../stores.js'

import {
  user,
  business,
  myOrder,
  showPopup,
  orderOnLogin,
  isAdmin,
  userDetails,
  OS,
} from "../stores.js";

import compareVersions from "compare-versions";
import { version } from "../../package.json";
import { querystring, location, push, pop } from "svelte-spa-router";


let functionsPrefetchInterval;
let callbacks = [];
let initComplete = false;

export function onInitComplete(cb) {
  if (initComplete) cb();
  else callbacks.push(cb);
}
export async function init() {
  if (window.cordova) {
    cordova.plugins.firebase.dynamiclinks.getDynamicLink().then(function (data) {
      if (data) {
        console.log("Read dynamic link data on app start:", data);
        handleDynamicLink(data)
      } else {
        console.log("App wasn't started from a dynamic link");
      }
    });
    cordova.plugins.firebase.dynamiclinks.onDynamicLink(function (data) {
      console.log("Dynamic link click with data:", data);
      handleDynamicLink(data)
    });
  }

  // if (!firebase.messaging || !firebase.messaging.isSupported()) {
  //     console.error(`Browser doesnt support messaging`)
  //     // showPopup(`Browser doesnt support messaging`, () => { });
  // } else {
  //     try {
  //         debugger;
  //         messaging = firebase.messaging();
  //         console.log(messaging)
  //     } catch (e) {
  //         showPopup(`Error initializing messaging: ${e.toString()}`, () => { });
  //     }
  // }

  //local dev
  const hostname = window.location.hostname
  console.log(`hostname: ${hostname}`)
  if (window.location.hostname === "localhost"
    //  ||
    // hostname === "192.168.43.12"  // Using emulators from local network doesnt work!!!
  ) {
    console.log("localhost detected!");
    if (useEmulator) {
      // functions;
      firebase.functions().useEmulator(hostname, 5001);

      // firestore
      firebase.firestore().settings({
        host: `${hostname}:8080`,
        ssl: false,
        experimentalForceLongPolling: true,
        merge: true,
      });
      console.log("using emulator");
    } else {
      console.log("on localhost but NOT using local emulators!");
    }
  }
  try {
    BusinessBL.checkAdmin();
    OrderDAL.unsubOrder()
    myOrder.set(null);
    user.set(null);
    isAdmin.set(false);
    userDetails.set(null)

    window.auth.listenToAuthState(authStateChanged)

    // FirebasePlugin.listenToDocumentInFirestoreCollection(function (event) {},(e) => {},
    // "version", "publicSettings");







    SettingsDAL.listenToMinVersion(
      async (versionData) => {
        if (!versionData) return;
        const serverMinVersion = versionData.version;
        console.log(`serverMinVersion: ${serverMinVersion}`)
        if (compareVersions(version, serverMinVersion) == -1) {
          if (window.cordova) {
            setTimeout(function () {
              clearCart();
              window.location.reload();
            });
          } else {
            showPopup(
              `קיימת גרסה חדשה יותר. לחצו אישור כדי לטעון את הגרסה.`,
              () => {
                setTimeout(function () {
                  clearCart();
                  window.location.reload();
                });
              }
            );
          }
        }
      },
    );
  } catch (e) {
    debugger;
    console.error(e)
    UserDAL.sendLog("listenToMinVersion", e.toString());
  }
  startPrefetchInterval();
  initComplete = true;
  callbacks.forEach((cb) => { cb(); })


  //   let firebaseAuthUI = firebaseui.auth.AuthUI(firebase.auth());
}

function handleDynamicLink(data) {
  if (!data || !data.deepLink) {
    console.log('empty deep link');
    return;
  }
  const link = data.deepLink;
  console.log(`link was: ${link}`)
  const splitted = link.split('/');
  const businessCode = splitted[splitted.length - 1];
  console.log(`pushing route: /b/${businessCode}`);
  push(`/b/${businessCode}`);
}

export async function authStateChanged(u) {
  console.log('authStateChanged')
  console.log(u)
  try {
    if (u) {
      // showPopup(`authStateChanged, u.uid: ${u.uid}`, () => { });
      console.log(`userId: ${u.uid}`)
      user.set(u);
      UserBL.listenToUserDetails(u);

      const ud = await UserDAL.getUserDetails(u);
      console.log('*** setting user details after login:')
      console.log(ud)
      userDetails.set(ud);
      console.log('calling listenToMyOrder')
      OrderBL.listenToMyOrder();
      //if user already gave notifications permission we init messaging
      if (!window.cordova) {
        if (Notification.permission === "granted") {
          MessagingBL.initMessaging();
        } else {
          UserDAL.setFcmToken(u.uid, '')
        }
      } else {
        var channel = {
          id: "my_channel_id",
          sound: "my_sound",
          name: "my_channel",
        };

        FirebasePlugin.createChannel(channel,
          function () {
            console.log('Channel created: ' + channel.id);
          },
          function (error) {
            console.log('Create channel error: ' + error);
          });
        FirebasePlugin.getToken(async function (_fcmToken) {
          try {
            console.log('fcmToken: ' + _fcmToken);
            fcmToken.set(_fcmToken);
            UserDAL.setFcmToken(u.uid, _fcmToken, get(OS))

            if (get(orderOnLogin)) {
              orderOnLogin.set(false);
              OrderBL.order();
            }
          } catch (e) {
            showPopup(`חלה שגיאה. יש להתנתק ולהתחבר שנית.`, () => { });
          }
        }, function (error) {
          console.error(error);
        });
      }

      let b = get(business);
      if (b) {
        //is admin?
        isAdmin.set(b.admins[u.uid]);
        BusinessBL.checkAdmin();

      }

    } else {

      // showPopup(`authStateChanged, no user`, () => { });
      OrderDAL.unsubOrder()
      myOrder.set(null);
      user.set(null);
      isAdmin.set(false);
      userDetails.set(null)
      // checkAdmin();
    }
  }
  catch (err) {
    debugger;
    console.error(err)
  }
}


export async function functionsPrefetch() {
  return;
  if (get(user)) {
    console.log('calling order function prefetch')
    await db.callable("order", { isPrefetch: true })


    console.log('calling orderReady function prefetch')
    await db.callable("orderReady", { isPrefetch: true })
  }
}





function startPrefetchInterval() {
  if (functionsPrefetchInterval) return;
  functionsPrefetch();

  functionsPrefetchInterval = setInterval(() => {
    functionsPrefetch();
  }, 1000 * 60 * 5);
}





